var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlameGreen = function SvgFlameGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3485_15625)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9241 1.27899C7.90607 0.899651 7.59184 0.585205 7.22584 0.686541C6.98774 0.752468 6.7554 0.849338 6.53417 0.977151C4.3942 2.21344 0.666504 4.98518 0.666504 9.29235C0.666504 13.4629 3.94974 15.3335 7.99984 15.3335C12.0499 15.3335 15.3332 13.4629 15.3332 9.29235C15.3332 6.15958 13.3612 3.83911 11.4624 2.33091C11.0934 2.03787 10.5591 2.24433 10.4036 2.6891C10.2105 3.24183 9.95384 3.75931 9.61727 4.08058C9.3386 4.34658 8.89897 4.27088 8.66654 3.96368C8.14874 3.27943 7.9687 2.21789 7.9241 1.27899ZM7.75757 7.7773C7.9112 7.7018 8.08847 7.7018 8.2421 7.7773C8.89927 8.1002 10.6665 9.13 10.6665 10.8667C10.6665 12.3394 9.4726 13 7.99984 13C6.52707 13 5.33317 12.3394 5.33317 10.8667C5.33317 9.13 7.1004 8.1002 7.75757 7.7773Z",
    fill: "#059669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24243 7.7773C8.0888 7.7018 7.91153 7.7018 7.7579 7.7773C7.10073 8.1002 5.3335 9.13 5.3335 10.8667C5.3335 12.3394 6.5274 13 8.00016 13C9.47293 13 10.6668 12.3394 10.6668 10.8667C10.6668 9.13 8.8996 8.1002 8.24243 7.7773Z",
    fill: "#D1FAE5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3485_15625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#fff"
  })))));
};
export default SvgFlameGreen;